import { LOCALE_DEFAULT } from "../constants/consts";
const formatDateTime = (date) => {
    if (!date) {
        return '-';
    }
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    const options = {
        weekday: undefined,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const fullDate = date.toLocaleDateString(LOCALE_DEFAULT, options);
    const hour = date.toLocaleTimeString();
    return `${fullDate} ás ${hour}`;
};
export { formatDateTime };
//# sourceMappingURL=format-date-time.js.map